import request from "@/shared/apis";

const BASE = "timetable-roles";

const roles = {
  grantAdmin: (dto) => request.post(`${BASE}/admin`, dto),
  grantFacultyOfficer: (dto) => request.post(`${BASE}/faculty-officer`, dto),
  grantDepartmentOfficer: (dto) => request.post(`${BASE}/department-officer`, dto),
};

export default roles;
